/*----------------------------------------------------------------------------
|
|    Product Image Component
|
|    Load & show product image from HermesWS
|
|    written by Tushar Lamba
|    Apr 2024
|
\---------------------------------------------------------------------------*/

import React from 'react';
import { BasicAlert } from '../components.jsx';
import { NoImageIcon } from '../icons.jsx';
import { GET } from '../restLib.js';

import './productImage.css';
import '../../widget/widget-style.css';

export class ProductImage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      hermesUrl: '',
      status: 'L',
      errorMsg: ''
    };

    this.getHermesWSUrl = this.getHermesWSUrl.bind(this);
    this.imgLoadError = this.imgLoadError.bind(this);
  }

  componentDidMount() {
    this.getHermesWSUrl();
  }

  // Get HermesWS Url from the DB
  getHermesWSUrl() {
    if (this.props.materialNo === '')
      return;

    const material = this.props.materialNo.split('#')[0];

    GET("/os/ossui/v1/in/widgetExpert/productImageLink?materialNo=" + material, {}, function (res) {
      if (res.status !== 'S') {
        this.setState({ status: res.status, errorMsg: res.message })
      } else {
        this.setState({ status: 'S', hermesUrl: res.data.hermes_url });
      }
    }.bind(this));
  }

  imgLoadError() {
    this.setState({ status: 'E', errorMsg: 'Image Load Error' });
    console.log('imgLoadError');
  }

  render() {

    const { hermesUrl, status, errorMsg } = this.state;
    const { width } = this.props;

    const disclaimer = this.props.disclaimer || 'DISCLAIMER: Product may slightly differ from the image.';
    const materialNo = this.props.materialNo || '';

    return (
      <div className='product-image' style={{ width: width || '100%' }}>
          {status === 'S' ? (
              <div className='product-image-disclaimer'>{disclaimer}</div>
            )
            : status === 'N' ? (
              <NoImageIcon style={{ maxWidth: '300px' }} width={width} />
            )
            : (
              <BasicAlert type={status} msg={errorMsg} />
            )
          }
          {status === 'S' && hermesUrl !== '' && (
              <img src={hermesUrl} alt={materialNo} width={width} onError={this.imgLoadError} />
            )
          }
      </div>
    );
  }
}

export default ProductImage;